export default __webpack_public_path__ + "static/media/end_order.0be35123.png";